let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("64fSG")).then(() => parcelRequire('95WYF'));